// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2RuXI","title":"ClientInsurance_title__1yjVt","itemText":"ClientInsurance_itemText__3eOOo"};